import React, { useState } from 'react';
import {
  Button,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Table,
  Paper,
  TableContainer,
  TablePagination,
  IconButton,
  Alert,
  Snackbar,
  CircularProgress,
  Backdrop
} from '@mui/material';
import { IoMdArrowBack } from 'react-icons/io';
import GetAppIcon from '@mui/icons-material/GetApp';
import { MandateFileDownload } from 'API/Mandate_Surrender';

const MandateView = (props) => {
  const Success = props.Success;
  const [Error, setError] = useState(false);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [Isloading, setIsloading] = useState(false);

  const handleDownload = (id) => {
    MandateFileDownload(id, setIsloading, setSuccessMsg, setError);
  };

  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Button sx={{ width: '20px' }} variant="outlined" onClick={() => props.setViewopen(false)}>
        <IoMdArrowBack style={{ fontSize: '20px' }} />
      </Button>
      <Paper sx={{ width: '70%' }}>
        <TableContainer
          sx={{
            maxHeight: 1000,
            width: 1190,
            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px'
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '8px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555'
            }
          }}
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '10%', color: '#592375' }}>File Name</TableCell>
                <TableCell sx={{ width: '10%', color: '#592375' }}>Bank Mandate file</TableCell>
                <TableCell sx={{ width: '10%', color: '#592375' }}>No of Mandate</TableCell>
                <TableCell sx={{ width: '10%', color: '#592375' }}>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Success &&
                Success.map((row, index) => (
                  <React.Fragment key={index}>
                    <TableRow hover role="checkbox" tabIndex={-1} sx={{ cursor: 'pointer' }}>
                      <TableCell sx={{ width: '10%' }}>{row.excel_file_name}</TableCell>
                      <TableCell sx={{ width: '10%' }}>{row.bank_mandate_file_name}</TableCell>
                      <TableCell sx={{ width: '10%' }}>{row.total_bcs_vacancy}</TableCell>
                      <TableCell sx={{ width: '10%' }}>
                        <IconButton aria-label="expand row" size="small" onClick={() => handleDownload(row.mandate_id)}>
                          <GetAppIcon color="secondary" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            // sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              mt: -3
            }}
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={props.TotalCount}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
          />
        </TableContainer>
      </Paper>
    </>
  );
};

export default MandateView;
